<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <template slot="title">
          <div class="row">
            <div class="col">
              <h3 class="mb-0">Cotizaciones Asociadas</h3>
            </div>

            <div class="col text-right pr-5"></div>
          </div>
        </template>
        <div v-if="queriedData.length > 0" class="table-responsive">
          <el-table :data="queriedData" header-row-class-name="thead-light">
            <el-table-column type="expand">
              <template #default="{ row }">
                <ul class="list-group list-group-flush list my--3">
                  <li v-for="item in row.items" :key="item.id" class="list-group-item px-0">
                    <div class="align-items-center">
                      <div class="row">
                        <div class="col-md-1 col-sm-12">
                          {{ item.article.code }}
                        </div>
                        <div class="col-md-3 col-sm-12">
                          <span class="font-weight-bold">{{ item.quantity }}</span
                          >&nbsp;x&nbsp;
                          <span>{{ item.article.description }}</span>
                        </div>
                        <div class="col-md-2 col-sm-12">{{ item.price | toCurrencyUSD }} .- c/u</div>
                        <div class="col-md-2 col-sm-12">
                          {{ (item.price * item.quantity) | toCurrencyUSD }}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li v-if="row.items.length" class="list-group-item px-0">
                    <div class="row">
                      <div class="col-md-1 offset-md-5 col-sm-1 offset-sm-1">
                        <span class="font-weight-bold">Total</span>
                      </div>
                      <div class="col-md-2 col-sm-10">
                        <span>
                          {{ row.items.reduce((acc, i) => (acc += i.quantity * i.price), 0) | toCurrencyUSD }}
                        </span>
                      </div>
                    </div>
                  </li>
                  <li v-if="!row.items.length" class="list-group-item px-0">Sin artículos.</li>
                </ul>
              </template>
            </el-table-column>

            <el-table-column label="Código" min-width="140px" prop="code" sortable>
              <template #default="{ row }">
                {{ row.code }}
              </template>
            </el-table-column>

            <el-table-column label="Fecha" min-width="120px" prop="date" sortable>
              <template #default="{ row }">
                {{ row.date | date('DD/MM/YYYY') }}
              </template>
            </el-table-column>

            <el-table-column label="Productor" min-width="150px" prop="producer" sortable>
              <template #default="{ row }">
                <div v-if="row.producer">
                  <router-link
                    v-if="$can('show', 'producers')"
                    :to="{
                      name: 'ProducerShow',
                      params: { id: row.producer.id },
                    }"
                    class="h5"
                  >
                    {{ row.producer.businessName }}
                  </router-link>
                  <p v-else>{{ row.producer.businessName }}</p>
                </div>
                <div v-if="row.producer.distributor">
                  <small>{{ row.producer.distributor.name }}</small>
                </div>
                <div v-if="row.producer.distributor.seller">
                  <small>{{ row.producer.distributor.seller.name }}</small>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Autor" min-width="120px" prop="user" sortable>
              <template #default="{ row }">
                {{ row.user.name }}
              </template>
            </el-table-column>

            <el-table-column label="Campaña" min-width="140px" prop="campaign" sortable>
              <template #default="{ row }">
                <div>{{ row.campaign.name }}</div>
              </template>
            </el-table-column>

            <el-table-column label="Estado" min-width="120px" prop="state" sortable>
              <template #default="{ row }">
                <div v-if="row.deletedAt">
                  <badge type="danger" class="m-1">Eliminado</badge>
                  <small class="text-break">por {{ row.updatedBy.name }} el {{ row.deletedAt | date }}</small>
                </div>
                <badge v-else :type="getColor(row)" class="m-1">{{ row.state.label }}</badge>
              </template>
            </el-table-column>

            <el-table-column align="right" label="" min-width="180px">
              <div slot-scope="{ row }" class="d-flex">
                <div v-if="!row.deletedAt">
                  <router-link
                    v-if="$can('show', 'quotations')"
                    :to="{ name: 'QuotationShow', params: { id: row.id } }"
                    class="btn base-button btn-outline-info btn-sm"
                  >
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link
                    v-if="$can('update', 'quotations') && !isSendedQuotation(row)"
                    :to="{ name: 'QuotationEdit', params: { id: row.id } }"
                    title="Editar"
                    class="btn base-button btn-outline-primary btn-sm"
                  >
                    <i class="fas fa-pen"></i>
                  </router-link>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="queriedData.length === 0" class="px-0">
          <div class="row align-items-center">
            <div class="col">
              <h4 class="mb-0">Esta Proyección no tiene Cotizaciones asociadas.</h4>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import QuotationsService from '@/services/resources/quotations.service';
import QuotationStatesMixin from '@/mixins/quotationStatesMixin';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'QuotationsList',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  mixins: [QuotationStatesMixin],
  props: {
    projectionId: null,
  },

  data() {
    return {
      quotations: [],
      queriedData: [],
    };
  },

  created() {
    this.fetchTableData();
  },

  methods: {
    fetchTableData() {
      const params = {
        include: ['producer.distributor.seller', 'campaign', 'user', 'state', 'items.article'],
        'filter[projection]': this.projectionId,
      };
      this.$services
        .resource('quotations')
        .get(params)
        .then((res) => {
          return res.data.data;
        })
        .then((data) => (this.queriedData = data.quotations));
    },

    isSendedQuotation(quotation) {
      return quotation.state !== null && quotation.state.name === QuotationsService._STATE_SENDED;
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__expand-column .cell {
  width: 20px;
}

::v-deep .el-table__expanded-cell p {
  word-break: break-word;
  white-space: normal;
}
</style>
